import { Injectable, Provider } from '@angular/core';
import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterState } from '@k2/common/routing/state';
import { RouterStateSerializer } from '@ngrx/router-store';

@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<RouterState> {
  serialize(routerState: RouterStateSnapshot): RouterState {
    const { url } = routerState;

    let route = routerState.root;
    let params: Params = {};
    let queryParams: Params = {};
    let serviceId: string;

    while (route) {
      params = { ...params, ...route.params };
      queryParams = { ...queryParams, ...route.queryParams };
      route = route.firstChild!;
    }

    // since service ids are hardcoded into the routes,
    // need to extract them from url instead of route params
    const segments = routerState.url.split('/');
    const serviceIdIndex = segments.indexOf('services');
    if (serviceIdIndex !== -1 && segments.length > serviceIdIndex + 1) {
      serviceId = segments[serviceIdIndex + 1];
    }
    if (serviceId) {
      params = {
        ...params,
        serviceId: serviceId
      };
    }

    return { url, params, queryParams };
  }
}

export const routerStateSerializerProvider: Provider = {
  provide: RouterStateSerializer,
  useClass: CustomRouterStateSerializer
};
